// Styles for normal text elements
import { css } from 'styled-components';
import { NIGHTINGALE_BLACK, SENSATION_WHITE } from '../../colors';
import { FONT_FAMILY_BASE } from '../../constants';
import { baseHighlightStyle } from '../../tokens/highlight';
import { baseSelectionStyle } from '../../tokens/selection';
export const baseTextStyle = `
  font-family: ${FONT_FAMILY_BASE};
  font-weight: 400;
  margin: 0;
  letter-spacing: 0;
  font-style: normal;
  font-stretch: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
export const baseTypographyStyle = css`
  color: ${({
  color,
  negative,
  inverse
}) => color || (negative || inverse ? SENSATION_WHITE : NIGHTINGALE_BLACK)};
  transition: color 0.2s ease-out;
  ${baseTextStyle}
  ${baseSelectionStyle}
  ${baseHighlightStyle}
`;